module.exports = __webpack_public_path__ + "static/media/image2.f4a071c4.jpg";